<form class="milestone-entry-body" [formGroup]="data.fg">
  <digires-checkbox
    [formGroup]="data.fg"
    formCtrlName="notApplicable"
    [disabled]="readOnly"
    tooltip="Not Applicable"
    labelPosition="before"
    [cssClasses]="{
      changed: data.initial.notApplicable !== data.fg.getRawValue().notApplicable,
      transparent: !data.ms.notApplicable,
    }"
    >N/A</digires-checkbox
  >

  <div class="col align-items-flex-start">
    <div class="row">
      <div class="milestone-entry-category">
        <mat-icon
          *ngIf="data.ms.category && data.ms.customRef"
          matTooltip="{{ categoryLabel }}"
          svgIcon="{{ categoryIcon }}"
        ></mat-icon>
      </div>
      <div class="milestone-entry-ref">
        {{ data.ms.customRef }}
      </div>
    </div>
    <!--row for when this milestone is dependent on others-->
    <div *ngIf="data.ms.hasIncomingDependencies" class="row">
      <div class="milestone-entry-color-dependency">
        {{ incomingDependenciesRefs }}
      </div>
      <mat-icon
        class="milestone-entry-category milestone-entry-color-dependency"
        svgIcon="milestone_dependency_incoming"
        matTooltip="This milestone is an Auto-Updated milestone. Its date and completion status is determined by the Predecessor milestones that are linked to it."
      ></mat-icon>
    </div>
    <!--row for when this milestone is a dependency for others-->
    <div *ngIf="data.ms.hasOutgoingDependencies" class="row">
      <mat-icon
        class="milestone-entry-category milestone-entry-color-dependency"
        svgIcon="milestone_dependency_outgoing"
        matTooltip=""
      ></mat-icon>
      <div class="milestone-entry-ref milestone-entry-color-dependency">
        {{ outgoingDependenciesRefs }}
      </div>
    </div>
  </div>

  <digires-state-indicator
    [readOnly]="readOnly || data.ms.synthetic || data.ms.hasIncomingDependencies"
    [readOnlyReason]="readOnlyReason"
  ></digires-state-indicator>

  <mat-form-field class="milestone-entry-name-input">
    <mat-label>{{ placeholder }}</mat-label>
    <label>
      <input
        matInput
        type="text"
        readonly
        value="{{ data.ms.name }}"
        matTooltip="{{ data.ms.name }}"
        [ngClass]="{
          'milestone-entry-synthetic': data.ms.synthetic || data.ms.hasIncomingDependencies,
          'milestone-entry-color-dependency': data.ms.hasIncomingDependencies,
          'milestone-entry-locked': data.fg.getRawValue().notApplicable,
        }"
      />
    </label>
  </mat-form-field>
  <mat-icon
    class="tooltip-icon"
    svgIcon="tooltip"
    matTooltipPosition="right"
    matTooltip="{{ cachedSummary }}"
  ></mat-icon>

  <mat-form-field>
    <mat-label>{{ data.fg.getRawValue().complete ? 'Completed On' : 'Forecast' }}</mat-label>
    <label>
      <input
        matInput
        formControlName="date"
        type="date"
        [required]="data.mandatory"
        [readonly]="
          readOnly ||
          data.fg.getRawValue().notApplicable ||
          data.fg.getRawValue().complete ||
          (!projectCreation && (data.ms.keyDataChange === 'cod' || data.ms.keyDataChange === 'fid'))
        "
        [ngClass]="{
          'milestone-entry-synthetic':
            data.ms.synthetic && !data.ms.hasIncomingDependencies && !data.fg.getRawValue().notApplicable,
          'milestone-entry-color-dependency': data.ms.hasIncomingDependencies && !data.fg.getRawValue().notApplicable,
          changed:
            !data.ms.synthetic &&
            data.initial.date !== data.fg.getRawValue().date &&
            !data.fg.getRawValue().notApplicable,
          'milestone-entry-locked': data.fg.getRawValue().notApplicable,
        }"
        (click)="onDateInputClicked($event)"
      />
    </label>
    <mat-error *ngIf="this.data.fg.get('date').invalid">
      {{ ValidatorUtil.getErrorMessage(this.data.fg.get('date')) }}
    </mat-error>
  </mat-form-field>

  <mat-icon
    *ngIf="!data.ms.synthetic && !data.ms.hasIncomingDependencies && isDateInPast()"
    class="warning-triangle"
    matTooltip="PLAUSIBILITY WARNING: Please check this date as it is an uncompleted date in the past.
            If this has now been completed place a tick in the Complete box otherwise re-forecast the date into
            the future."
  >
    warning
  </mat-icon>
  <mat-icon
    *ngIf="!data.ms.synthetic && !data.ms.hasIncomingDependencies && isDateInFuture()"
    class="warning-triangle"
    matTooltip="PLAUSIBILITY WARNING: Please check this date as it is a completed date in the future.
            If this has not yet been completed remove the tick from the Complete box otherwise change the date to
            when the milestone was completed in the past."
  >
    warning
  </mat-icon>
  <mat-icon
    *ngIf="data.ms.synthetic || data.ms.hasIncomingDependencies || (!isDateInPast() && !isDateInFuture())"
    class="warning-triangle transparent"
  >
    warning
  </mat-icon>

  <digires-checkbox
    [formGroup]="data.fg"
    formCtrlName="complete"
    [disabled]="
      readOnly ||
      data.fg.getRawValue().notApplicable ||
      (!data.fg.getRawValue().complete && (!data.fg.getRawValue().date || !data.fg.valid))
    "
    tooltip="Completed"
    labelPosition="after"
    [cssClasses]="{
      'milestone-entry-synthetic': data.ms.synthetic || data.ms.hasIncomingDependencies,
      changed: !data.ms.synthetic && data.initial.complete !== data.fg.getRawValue().complete,
      'milestone-entry-locked': data.fg.getRawValue().notApplicable,
    }"
  ></digires-checkbox>

  <mat-icon class="milestone-entry-icon" [ngClass]="{ transparent: !data.ms.key }" matTooltip="This is a key milestone">
    vpn_key
  </mat-icon>

  <mat-icon
    class="milestone-entry-icon"
    [ngClass]="{ transparent: !data.ms.includeIfHybrid }"
    matTooltip="This milestone is only shown when the project is a hybrid (i.e. a mix of Technologies)"
    svgIcon="milestone_include_if_hybrid"
  >
  </mat-icon>

  <mat-icon
    class="milestone-entry-icon"
    [ngClass]="{ transparent: !data.ms.includeIfDivestment }"
    matTooltip="This milestone is only shown when the project’s Business Model includes Divestment (i.e. Build & Sell (All); Build & Sell (Part) or Develop & Sell.)"
    svgIcon="milestone_include_if_divestment"
  >
  </mat-icon>
</form>
